export default "__VITE_ASSET__C1zxV5VS__"